import { AppRoutes } from './routes/Routes';
import './styles/App.css';
import './styles/index.css';

function App() {
  return (
    <>
      <AppRoutes />
    </>
  );
}

export default App;